import React from 'react';
import st from './styles.module.scss';
import { Align, TextType } from "@baseTypes/baseType";
import ChartHeader from "@elements/chart/ChartHeader";
import Tx from "@baseTypes/naming";
import FlexLine from "@elements/flexLine/FlexLine";
import { EmptyTextBlock } from "@pages/dashboard/crops/empty";

const Empty = () => {
	return (
		<div className={st['empty']}>
			<FlexLine textType={TextType.Header} align={Align.SpaceBetween} style={{paddingBottom: '20px'}}>
				<ChartHeader>{Tx.VehicleTypes}</ChartHeader>
			</FlexLine>
			<svg width="352" height="244" viewBox="0 0 352 244" fill="none" xmlns="http://www.w3.org/2000/svg">
				<rect y="4" width="32" height="12.25" rx="6.125" fill="#E6E6E6"/>
				<g clipPath="url(#clip0_11156_6926)">
					<rect x="184.5" y="3.5" width="26.6138" height="13" fill="#E6E6E6" stroke="#E6E6E6"/>
					<rect x="214.114" y="3.5" width="106.945" height="13" fill="#E6E6E6" stroke="#E6E6E6"/>
					<rect x="324.059" y="3.5" width="13" height="13" fill="#E6E6E6" stroke="#E6E6E6"/>
					<rect x="340.059" y="3.5" width="11.4414" height="13" fill="#E6E6E6" stroke="#E6E6E6"/>
				</g>
				<rect y="36" width="63" height="12.25" rx="6.125" fill="#E6E6E6"/>
				<g clipPath="url(#clip1_11156_6926)">
					<rect x="184.5" y="35.5" width="83.0965" height="13" fill="#E6E6E6" stroke="#E6E6E6"/>
					<rect x="270.597" y="35.5" width="41.6759" height="13" fill="#E6E6E6" stroke="#E6E6E6"/>
					<rect x="315.272" y="35.5" width="9.04138" height="13" fill="#E6E6E6" stroke="#E6E6E6"/>
					<rect x="327.314" y="35.5" width="14" height="13" fill="#E6E6E6" stroke="#E6E6E6"/>
					<rect x="344.314" y="35.5" width="7.18621" height="13" fill="#E6E6E6" stroke="#E6E6E6"/>
				</g>
				<rect y="68" width="48" height="12.25" rx="6.125" fill="#E6E6E6"/>
				<g clipPath="url(#clip2_11156_6926)">
					<rect x="184.5" y="67.5" width="104" height="13" fill="#E6E6E6" stroke="#E6E6E6"/>
					<rect x="291.5" y="67.5" width="11.5517" height="13" fill="#E6E6E6" stroke="#E6E6E6"/>
					<rect x="306.052" y="67.5" width="9.04138" height="13" fill="#E6E6E6" stroke="#E6E6E6"/>
					<rect x="318.093" y="67.5" width="19" height="13" fill="#E6E6E6" stroke="#E6E6E6"/>
					<rect x="340.093" y="67.5" width="11.4069" height="13" fill="#E6E6E6" stroke="#E6E6E6"/>
				</g>
				<rect y="96" width="46" height="12.25" rx="6.125" fill="#E6E6E6"/>
				<path
					d="M184.5 103C184.5 101.067 186.067 99.5 188 99.5H215.5V112.5H188C186.067 112.5 184.5 110.933 184.5 109V103Z"
					fill="#E6E6E6" stroke="#E6E6E6"/>
				<rect x="218.5" y="99.5" width="31" height="13" fill="#E6E6E6" stroke="#E6E6E6"/>
				<path d="M252 99H284V113H252V99Z" fill="#E6E6E6"/>
				<rect x="286.5" y="99.5" width="31" height="13" fill="#E6E6E6" stroke="#E6E6E6"/>
				<path
					d="M320.5 99.5H348C349.933 99.5 351.5 101.067 351.5 103V109C351.5 110.933 349.933 112.5 348 112.5H320.5V99.5Z"
					fill="#E6E6E6" stroke="#E6E6E6"/>
				<rect y="128" width="68" height="12.25" rx="6.125" fill="#E6E6E6"/>
				<g clipPath="url(#clip3_11156_6926)">
					<rect x="184.5" y="131.5" width="167" height="13" fill="#E6E6E6" stroke="#E6E6E6"/>
				</g>
				<rect y="160" width="43" height="12.25" rx="6.125" fill="#E6E6E6"/>
				<g clipPath="url(#clip4_11156_6926)">
					<rect x="184.5" y="163.5" width="82" height="13" fill="#E6E6E6" stroke="#E6E6E6"/>
					<rect x="269.5" y="163.5" width="82" height="13" fill="#E6E6E6" stroke="#E6E6E6"/>
				</g>
				<rect y="192" width="41" height="12.25" rx="6.125" fill="#E6E6E6"/>
				<g clipPath="url(#clip5_11156_6926)">
					<rect x="184.5" y="195.5" width="76.8207" height="13" fill="#E6E6E6" stroke="#E6E6E6"/>
					<rect x="264.321" y="195.5" width="14.0621" height="13" fill="#E6E6E6" stroke="#E6E6E6"/>
					<rect x="281.383" y="195.5" width="70.1172" height="13" fill="#E6E6E6" stroke="#E6E6E6"/>
				</g>
				<rect y="224" width="90" height="12.25" rx="6.125" fill="#E6E6E6"/>
				<g clipPath="url(#clip6_11156_6926)">
					<rect x="184.5" y="227.5" width="109" height="13" fill="#E6E6E6" stroke="#E6E6E6"/>
					<rect x="296.5" y="227.5" width="14.0621" height="13" fill="#E6E6E6" stroke="#E6E6E6"/>
					<rect x="313.562" y="227.5" width="37.9379" height="13" fill="#E6E6E6" stroke="#E6E6E6"/>
				</g>
				<defs>
					<clipPath id="clip0_11156_6926">
						<rect x="184" y="3" width="168" height="14" rx="4" fill="white"/>
					</clipPath>
					<clipPath id="clip1_11156_6926">
						<rect x="184" y="35" width="168" height="14" rx="4" fill="white"/>
					</clipPath>
					<clipPath id="clip2_11156_6926">
						<rect x="184" y="67" width="168" height="14" rx="4" fill="white"/>
					</clipPath>
					<clipPath id="clip3_11156_6926">
						<rect x="184" y="131" width="168" height="14" rx="4" fill="white"/>
					</clipPath>
					<clipPath id="clip4_11156_6926">
						<rect x="184" y="163" width="168" height="14" rx="4" fill="white"/>
					</clipPath>
					<clipPath id="clip5_11156_6926">
						<rect x="184" y="195" width="168" height="14" rx="4" fill="white"/>
					</clipPath>
					<clipPath id="clip6_11156_6926">
						<rect x="184" y="227" width="168" height="14" rx="4" fill="white"/>
					</clipPath>
				</defs>
			</svg>

			<div className={st['empty__blur']}>
				<svg width="400" height="400" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg">
					<rect width="400" height="400" fill="url(#paint0_linear_11156_6920)"/>
					<defs>
						<linearGradient id="paint0_linear_11156_6920" x1="200" y1="42.6063" x2="200" y2="311.874"
										gradientUnits="userSpaceOnUse">
							<stop offset="0.460045" stopColor="white" stopOpacity="0"/>
							<stop offset="0.831741" stopColor="white" stopOpacity="0.958507"/>
							<stop offset="1" stopColor="white"/>
						</linearGradient>
					</defs>
				</svg>

			</div>
			<EmptyTextBlock subtitle={'Для просмотра выберите другие департамент или организацию'} />
		</div>
	)
}

export default Empty;